/**
 * Wspólny bootstrap aplikacji Vue (header, footer, formularze, chunki lazy).
 * Używany przez osobne entry webpacka (main, page-contact), żeby podstrony
 * mogły mieć własny bundle bez duplikacji logiki.
 */
import Vue from 'vue';
import App from './App.vue';
import i18n from './i18n';

export async function bootstrapVueApp() {
  if (typeof document !== 'undefined' && document.querySelector('swiper')) {
    await import('./swiper-bootstrap');
  }
  await import('./app');

  let lottieLazy = null;
  if (typeof document !== 'undefined' && document.querySelector('lottie-player')) {
    lottieLazy = await import('./lottie-lazy');
  }

  const vm = new Vue({
    i18n,
    ...App
  });

  // initLottieLazy po mount — duża paczka @lottiefiles dopiero przy pierwszym wejściu
  // w viewport (dla data-src) albo od razu tylko przy animacjach inline bez data-src.
  if (lottieLazy) {
    vm.$nextTick(() => {
      void lottieLazy.initLottieLazy();
    });
  }
}
